import { logEvent } from "firebase/analytics";
import { getAnalyticsInstance } from "./analytics_initialization";
import { getCurrentDeviceData } from "../utils/helpers/universalFunctions";


let deviceData = getCurrentDeviceData()

export const trackEvent = (eventName, params = {}) => {
  const analytics = getAnalyticsInstance();
  params = {...params, ...deviceData}
  if (!analytics) return;
  
  logEvent(analytics, eventName, params);
};
